// import React from 'react'
// import { Container, Button } from 'react-bootstrap'
// import { useNavigate } from 'react-router-dom'
// import { FaArrowLeft } from 'react-icons/fa'
// import Navbar from './Navbar'
// import Swal from 'sweetalert2'

// const Partners = () => {
//   const navigate = useNavigate()

//   // Function to navigate back
//   const handleBack = () => {
//     navigate(-1) // Goes back to the previous page
//   }

//   // Partner Data Array
//   const partnerData = [
//     {
//       title: 'Muscle Movement Physical & Mental Wellness Training',
//       ctaType: 'Interested',
//     },
//     {
//       title: '24/7 AI Therapist',
//       ctaType: 'Interested',
//     },
//     {
//       title: 'Comprehensive Health Checks',
//       ctaType: 'Interested',
//     },
//     {
//       title: 'AI Training & Internships',
//       ctaType: 'Apply',
//       link: 'https://kaas.tdtlworld.com/',
//     },
//     {
//       title: 'AI Global Museum Access',
//       ctaType: 'Coming Soon',
//     },
//     {
//       title: '100% Scholarships',
//       ctaType: 'Form',
//       formRoute: '/scholarship',
//     },
//     {
//       title: 'AI Legal & Civil Rights Assistance',
//       ctaType: 'Unlock',
//     },
//     {
//       title: 'Financial Literacy Programs',
//       ctaType: 'Unlock',
//     },
//     {
//       title: 'Karnataka Ratna Assessment',
//       ctaType: 'Unlock',
//     },
//     {
//       title: 'Access to 250+ Monuments across India through AR / VR',
//       ctaType: 'Get Access',
//     },
//     {
//       title:
//         'Participation in Government Initiatives for Industry & Global Audience',
//       ctaType: 'Interested',
//     },
//     {
//       title:
//         'Access to Research, Scientific Innovations, Events from Top Universities',
//       ctaType: 'Unlock',
//     },
//     {
//       title: 'Language Training',
//       ctaType: 'Form',
//       formRoute: '/language-training',
//     },
//     {
//       title:
//         'UK, US, Australia High Commission sessions for Visa & Global Opportunities',
//       ctaType: 'Interested',
//     },
//     {
//       title: 'Inspirations',
//       ctaType: 'Unlock',
//     },
//   ]

//   // Handle CTA actions
//   const handleCTA = (ctaType, link, formRoute) => {
//     if (ctaType === 'Interested') {
//       Swal.fire('Thank You!', 'We will get back to you shortly.', 'success')
//     } else if (ctaType === 'Apply' && link) {
//       window.open(link, '_blank')
//     } else if (ctaType === 'Form' && formRoute) {
//       navigate(formRoute)
//     } else if (ctaType === 'Unlock') {
//       Swal.fire('Unlocked!', 'You can have an access now.', 'success')
//     } else if (ctaType === 'Get Access') {
//       Swal.fire('Email Sent!', 'You will receive an access link.', 'success')
//     }
//   }

//   return (
//     <>
//       <Navbar />
//       <div className='container-fluid py-4 bg-container'>
//         {/* Back Button */}
//         <button
//           className='btn btn-light d-flex align-items-center mb-4'
//           onClick={handleBack}
//         >
//           <FaArrowLeft className='me-2' /> Back
//         </button>

//         <Container className='mt-5 p-4 bg-white rounded-4 shadow-lg'>
//           <h2 className='text-danger text-center mb-5'>Partners</h2>

//           <div className='row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4'>
//             {partnerData.map((partner, index) => (
//               <div key={index} className='col'>
//                 <div
//                   className='card h-100 shadow-sm'
//                   style={{
//                     backgroundColor: '#FFFFFF',
//                     borderRadius: '12px',
//                     border: '2px solid #B02013',
//                     transition: 'transform 0.2s ease-in-out',
//                     cursor: 'pointer',
//                   }}
//                 >
//                   <div className='card-body text-center'>
//                     <h5
//                       className='card-title'
//                       style={{ color: '#B02013', fontWeight: 'bold' }}
//                     >
//                       {partner.title}
//                     </h5>
//                     <p className='card-text'>{partner.description}</p>

//                     {/* Conditional CTA Rendering */}
//                     {partner.ctaType === 'Coming Soon' ? (
//                       <Button variant='danger' disabled>
//                         Coming Soon
//                       </Button>
//                     ) : (
//                       <Button
//                         variant='danger'
//                         className='mt-3'
//                         onClick={() =>
//                           handleCTA(
//                             partner.ctaType,
//                             partner.link,
//                             partner.formRoute
//                           )
//                         }
//                       >
//                         {partner.ctaType === 'Apply'
//                           ? 'Apply Now'
//                           : partner.ctaType === 'Form'
//                           ? 'Fill Form'
//                           : partner.ctaType === 'Get Access'
//                           ? 'Get Me Access'
//                           : partner.ctaType}
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </Container>
//       </div>
//     </>
//   )
// }

// export default Partners

// import React from 'react'
// import { Container, Button } from 'react-bootstrap'
// import { useNavigate } from 'react-router-dom'
// import { FaArrowLeft } from 'react-icons/fa'
// import Navbar from './Navbar'
// import Swal from 'sweetalert2'

// const Partners = () => {
//   const navigate = useNavigate()

//   const handleBack = () => {
//     navigate(-1)
//   }

//   const partnerData = [
//     {
//       title: 'Assessments',
//       ctaType: 'Multiple',
//       assessments: [
//         {
//           name: 'Self-Reporting Questionnaire',
//           route: '/assessmentsOne',
//         },
//         {
//           name: 'Connor-Davidson Resilience Scale: (CD-RISC-10), 2003',
//           route: '/assessmentsTwo',
//         },
//       ],
//     },
//     {
//       title: 'Aarava - 24/7 Access AI Therapist',
//       ctaType: 'Get Access',
//       formRoute: '/ai-therapist',
//     },
//   ]

//   const handleCTA = (ctaType, link, formRoute) => {
//     if (ctaType === 'Interested') {
//       Swal.fire('Thank You!', 'We will get back to you shortly.', 'success')
//     } else if (ctaType === 'Apply' && link) {
//       window.open(link, '_blank')
//     } else if (ctaType === 'Form' && formRoute) {
//       navigate(formRoute)
//     } else if (ctaType === 'Unlock') {
//       Swal.fire('Unlocked!', 'You can have an access now.', 'success')
//     } else if (ctaType === 'Get Access') {
//       Swal.fire('Email Sent!', 'You will receive an access link.', 'success')
//     }
//   }

//   return (
//     <>
//       <Navbar />
//       <div className='container-fluid py-4 bg-container'>
//         <button
//           className='btn btn-light d-flex align-items-center mb-4'
//           onClick={handleBack}
//         >
//           <FaArrowLeft className='me-2' /> Back
//         </button>

//         <Container className='mt-5 p-4 bg-white rounded-4 shadow-lg'>
//           <h2 className='text-primary text-center mb-5'>Partners</h2>

//           <div className='row row-cols-2 row-cols-md-2 row-cols-lg-2 g-4'>
//             {partnerData.map((partner, index) => (
//               <div key={index} className='col'>
//                 <div
//                   className='card h-100 shadow-sm'
//                   style={{
//                     backgroundColor: '#FFFFFF',
//                     borderRadius: '12px',
//                     border: '2px solid #8DB8D4',
//                     transition: 'transform 0.2s ease-in-out',
//                     cursor: 'pointer',
//                   }}
//                 >
//                   <div className='card-body text-center'>
//                     <h5
//                       className='card-title'
//                       style={{ color: '#002740', fontWeight: 'bold' }}
//                     >
//                       {partner.title}
//                     </h5>
//                     <p className='card-text'>{partner.description}</p>

//                     {/* Conditional Rendering for Multiple Assessments */}
//                     {partner.ctaType === 'Multiple' && partner.assessments ? (
//                       partner.assessments.map((assessment, i) => (
//                         <Button
//                           key={i}
//                           className='m-2'
//                           style={{
//                             backgroundColor: '#2D5272',
//                             borderColor: '#2D5272',
//                           }}
//                           onClick={() => navigate(assessment.route)}
//                         >
//                           {assessment.name}
//                         </Button>
//                       ))
//                     ) : partner.ctaType === 'Coming Soon' ? (
//                       <Button
//                         style={{
//                           backgroundColor: '#2D5272',
//                           borderColor: '#2D5272',
//                         }}
//                         disabled
//                       >
//                         Coming Soon
//                       </Button>
//                     ) : (
//                       <Button
//                         className='mt-3'
//                         style={{
//                           backgroundColor: '#2D5272',
//                           borderColor: '#2D5272',
//                         }}
//                         onClick={() =>
//                           handleCTA(
//                             partner.ctaType,
//                             partner.link,
//                             partner.formRoute
//                           )
//                         }
//                       >
//                         {partner.ctaType === 'Apply'
//                           ? 'Apply Now'
//                           : partner.ctaType === 'Form'
//                           ? 'Fill Form'
//                           : partner.ctaType === 'Get Access'
//                           ? 'Get Me Access'
//                           : partner.ctaType}
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </Container>
//       </div>
//     </>
//   )
// }

// export default Partners

import { Container, Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { FaArrowLeft } from 'react-icons/fa'
import Navbar from './Navbar'
import Swal from 'sweetalert2'

const Partners = () => {
  const navigate = useNavigate()

  const handleBack = () => {
    navigate(-1)
  }

  const partnerData = [
    {
      title: 'Assessments',
      ctaType: 'Multiple',
      assessments: [
        {
          name: 'Self-Reporting Questionnaire',
          route: '/assessmentsOne',
        },
        {
          name: 'Connor-Davidson Resilience Scale: (CD-RISC-10), 2003',
          route: '/assessmentsTwo',
        },
      ],
    },
    {
      title: 'Aarava - 24/7 Access AI Therapist',
      ctaType: 'Get Access',
      formRoute: '/ai-therapist',
    },
  ]

  const handleCTA = (ctaType, link, formRoute) => {
    if (ctaType === 'Interested') {
      Swal.fire('Thank You!', 'We will get back to you shortly.', 'success')
    } else if (ctaType === 'Apply' && link) {
      window.open(link, '_blank')
    } else if (ctaType === 'Form' && formRoute) {
      navigate(formRoute)
    } else if (ctaType === 'Unlock') {
      Swal.fire('Unlocked!', 'You can have an access now.', 'success')
    } else if (ctaType === 'Get Access') {
      Swal.fire('Email Sent!', 'You will receive an access link.', 'success')
    }
  }

  return (
    <>
      <Navbar />
      <div className='container-fluid py-3 py-md-4 bg-container'>
        {/* Responsive Back Button */}
        <button
          className='btn btn-light d-flex align-items-center mb-3 mb-md-4 px-3 py-2'
          onClick={handleBack}
          style={{ fontSize: 'clamp(0.875rem, 2vw, 1rem)' }}
        >
          <FaArrowLeft className='me-2' />
          <span className='d-none d-sm-inline'>Back</span>
        </button>

        {/* Responsive Container */}
        <Container className='mt-3 mt-md-5 p-3 p-md-4 p-lg-5 bg-white rounded-4 shadow-lg'>
          {/* Responsive Title */}
          <h2
            className='text-primary text-center mb-4 mb-md-5 fw-bold'
            style={{ fontSize: 'clamp(1.5rem, 4vw, 2.5rem)' }}
          >
            Partners
          </h2>

          {/* Responsive Grid - Single column on mobile, 2 columns on medium+ */}
          <div className='row row-cols-1 row-cols-md-2 g-3 g-md-4'>
            {partnerData.map((partner, index) => (
              <div key={index} className='col'>
                <div
                  className='card h-100 shadow-sm'
                  style={{
                    backgroundColor: '#FFFFFF',
                    borderRadius: '12px',
                    border: '2px solid #8DB8D4',
                    transition: 'transform 0.2s ease-in-out',
                    cursor: 'pointer',
                  }}
                >
                  {/* Responsive Card Body */}
                  <div className='card-body text-center p-3 p-md-4'>
                    {/* Responsive Card Title */}
                    <h5
                      className='card-title fw-bold mb-3'
                      style={{
                        color: '#002740',
                        fontSize: 'clamp(1.1rem, 3vw, 1.5rem)',
                        lineHeight: '1.3',
                      }}
                    >
                      {partner.title}
                    </h5>

                    {partner.description && (
                      <p
                        className='card-text mb-3'
                        style={{ fontSize: 'clamp(0.875rem, 2.5vw, 1rem)' }}
                      >
                        {partner.description}
                      </p>
                    )}

                    {/* Conditional Rendering for Multiple Assessments */}
                    {partner.ctaType === 'Multiple' && partner.assessments ? (
                      <div className='d-flex flex-column flex-sm-row flex-wrap justify-content-center gap-2'>
                        {partner.assessments.map((assessment, i) => (
                          <Button
                            key={i}
                            className='mb-2 mb-sm-0 mx-1'
                            style={{
                              backgroundColor: '#2D5272',
                              borderColor: '#2D5272',
                              fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                              padding:
                                'clamp(0.375rem, 1.5vw, 0.75rem) clamp(0.75rem, 3vw, 1rem)',
                              lineHeight: '1.2',
                              whiteSpace: 'normal',
                              wordWrap: 'break-word',
                              minHeight: '2.5rem',
                            }}
                            onClick={() => navigate(assessment.route)}
                          >
                            {assessment.name}
                          </Button>
                        ))}
                      </div>
                    ) : partner.ctaType === 'Coming Soon' ? (
                      <Button
                        className='mt-2 mt-md-3'
                        style={{
                          backgroundColor: '#2D5272',
                          borderColor: '#2D5272',
                          fontSize: 'clamp(0.875rem, 2.5vw, 1rem)',
                          padding:
                            'clamp(0.5rem, 2vw, 0.75rem) clamp(1rem, 4vw, 1.5rem)',
                        }}
                        disabled
                      >
                        Coming Soon
                      </Button>
                    ) : (
                      <Button
                        className='mt-2 mt-md-3'
                        style={{
                          backgroundColor: '#2D5272',
                          borderColor: '#2D5272',
                          fontSize: 'clamp(0.875rem, 2.5vw, 1rem)',
                          padding:
                            'clamp(0.5rem, 2vw, 0.75rem) clamp(1rem, 4vw, 1.5rem)',
                        }}
                        onClick={() =>
                          handleCTA(
                            partner.ctaType,
                            partner.link,
                            partner.formRoute
                          )
                        }
                      >
                        {partner.ctaType === 'Apply'
                          ? 'Apply Now'
                          : partner.ctaType === 'Form'
                          ? 'Fill Form'
                          : partner.ctaType === 'Get Access'
                          ? 'Get Me Access'
                          : partner.ctaType}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </div>
    </>
  )
}

export default Partners
